/**
 * NavV2Gate — Flag-gated wrapper for Navigation V2 routes
 *
 * When ENABLE_NAVIGATION_V2 is OFF, redirects to the safe root route.
 * When ON, renders children.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';

interface Props {
  fallback: string;
  children: React.ReactNode;
}

const NavV2Gate: React.FC<Props> = ({ fallback, children }) => {
  const enabled = useFeatureFlag('enable_navigation_v2');
  if (!enabled) return <Navigate to={fallback} replace />;
  return <>{children}</>;
};

export default NavV2Gate;
